<section class="notification-dialog">
    <div class="notification-dialog-close">
        <img src="./assets/images/close.png" alt="close button" class="notification-dialog-close-button" (click)="closeDialog()">
    </div>
    <app-notification-detail [notificationItem]="data"></app-notification-detail>
    <!-- <button mat-button class="notification-dialog-button" ngStyle.lt-md="margin-left: 5px;">
        Check order details
    </button> -->
</section>